import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useGeocoder } from '../api/geocoderApi';
import {
  setDirectionsOrigin,
  setDirectionsDestination,
  setLabelOrigin,
  setLabelDestination,
} from '../store/actions/directionsActions';
import { promiseTimeout } from './timeoutPromise';

export const useMarker = () => {
  const dispatch = useDispatch();
  const { reverse } = useGeocoder();
  const { i18n } = useTranslation();

  const renderLabel = (feature) => {
    if (i18n.language === 'fr') {
      return feature.place_name_fr || feature.place_name;
    } else {
      return feature.feature_name_en || feature.place_name;
    }
  };

  /**
   *
   * @param {Lnglat de nouvelle position de marker} lngLat
   * @returns label de nouvelle position
   */

  const getAdressAndNewPosition = async (lngLat) => {
    let label = `${lngLat[0]}, ${lngLat[1]}`;
    try {
      const response = await promiseTimeout(
        reverse(lngLat[0], lngLat[1], `${i18n.language}`),
        5000,
      );
      if (response !== undefined) {
        const { features } = response;
        const label = renderLabel(features[0]);
        return label;
      }
    } catch (error) {
      console.log(`Geocoder reverse takes too much time: ${error}`);
      return label;
    }
  };
  const setMarker = async (lngLat, markerCase) => {
    const lng = lngLat[0];
    const lat = lngLat[1];
    if (markerCase === 'origin') {
      dispatch(setDirectionsOrigin(lngLat, `${lng}, ${lat}`));
      const label = await getAdressAndNewPosition(lngLat);
      dispatch(setLabelOrigin(label));
    } else if (markerCase === 'destination') {
      dispatch(setDirectionsDestination(lngLat, `${lng}, ${lat}`));
      const label = await getAdressAndNewPosition(lngLat);
      dispatch(setLabelDestination(label));
    }
  };
  return { setMarker, getAdressAndNewPosition };
};
